// src/components/Layout/Sidebar.js
import React from 'react';
import { NavLink } from 'react-router-dom';
import styles from './Sidebar.module.css';


const Sidebar = () => {
  return (
    <aside className={styles.sidebar}>
      <div className={styles.logoContainer}>
        {/* Logo veya boş alan - başlık header'da gösteriliyor */}
      </div>
      <nav>
        <ul>
          <li>
            <NavLink
              to="/orders"
              className={({ isActive }) => isActive ? `${styles.navLink} ${styles.active}` : styles.navLink}
            >
              Siparişler
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/packages"
              className={({ isActive }) => isActive ? `${styles.navLink} ${styles.active}` : styles.navLink}
            >
              E-Sim Paketleri (Ülkeler)
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/regions-package"
              className={({ isActive }) => isActive ? `${styles.navLink} ${styles.active}` : styles.navLink}
            >
              E-Sim Paketleri (Bölgeler)
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/lifetime-packages"
              className={({ isActive }) => isActive ? `${styles.navLink} ${styles.active}` : styles.navLink}
            >
              E-Sim Paketleri (Ön Ödemeli)
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/continents"
              className={({ isActive }) => isActive ? `${styles.navLink} ${styles.active}` : styles.navLink}
            >
              Kıtalar
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/countries"
              className={({ isActive }) => isActive ? `${styles.navLink} ${styles.active}` : styles.navLink}
            >
              Ülkeler
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/regions"
              className={({ isActive }) => isActive ? `${styles.navLink} ${styles.active}` : styles.navLink}
            >
              Bölgeler
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/users"
              className={({ isActive }) => isActive ? `${styles.navLink} ${styles.active}` : styles.navLink}
            >
              Kullanıcılar
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/configurations"
              className={({ isActive }) => isActive ? `${styles.navLink} ${styles.active}` : styles.navLink}
            >
              Konfigürasyonlar
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/content-management"
              className={({ isActive }) => isActive ? `${styles.navLink} ${styles.active}` : styles.navLink}
            >
              İçerik Yönetimi
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/settings"
              className={({ isActive }) => isActive ? `${styles.navLink} ${styles.active}` : styles.navLink}
            >
              Ayarlar
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/app-settings"
              className={({ isActive }) => isActive ? `${styles.navLink} ${styles.active}` : styles.navLink}
            >
              Uygulama Ayarları
            </NavLink>
          </li>
        </ul>
      </nav>
    </aside>
  );
};

export default Sidebar;